<div class="portal-form-wrapper">
  <div class="portal-form-header">
    <h2 class="portal-form-title">
      <mat-icon class="title-icon">add_business</mat-icon>
      Новий портал
    </h2>
    <p class="portal-form-subtitle">Заповніть дані для створення порталу</p>
  </div>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="portal-form">
    <div class="form-section">
      <h3 class="section-title">Основна інформація</h3>

      <div class="form-row form-row--full">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Назва порталу</mat-label>
          <input matInput formControlName="name" placeholder="Введіть назву" />
          @if (form.get('name')?.invalid && form.get('name')?.touched) {
          <mat-error>Назва обов'язкова</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="form-row form-row--half">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Ім'я</mat-label>
          <input matInput formControlName="firstName" placeholder="Введіть ім'я" />
          @if (form.get('firstName')?.invalid && form.get('firstName')?.touched) {
          <mat-error>Ім'я обов'язкове</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Прізвище</mat-label>
          <input matInput formControlName="lastName" placeholder="Введіть прізвище" />
        </mat-form-field>
      </div>

      <div class="form-row form-row--half">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Електронна пошта</mat-label>
          <input matInput type="email" formControlName="email" placeholder="email@example.com" />
          @if (form.get('email')?.invalid && form.get('email')?.touched) {
          <mat-error>
            @if (form.get('email')?.errors?.['required']) { Електронна пошта обов'язкова } @else if
            (form.get('email')?.errors?.['email']) { Невірний формат email }
          </mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Телефон</mat-label>
          <input matInput formControlName="phone" placeholder="+380..." />
        </mat-form-field>
      </div>

      <div class="form-row form-row--locale">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Мова</mat-label>
          <mat-select formControlName="locale">
            @for (loc of localeOptions; track loc.value) {
            <mat-option [value]="loc.value">{{ loc.label }}</mat-option>
            }
          </mat-select>
          @if (form.get('locale')?.invalid && form.get('locale')?.touched) {
          <mat-error>Оберіть мову</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="form-row form-row--full">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Адреса публічного кар'єрного сайту</mat-label>
          <input matInput formControlName="jobBoardUrl" placeholder="https://..." />
        </mat-form-field>
      </div>

      <div class="form-row form-row--half">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>План підписки</mat-label>
          <mat-select formControlName="subscription">
            @for (plan of subscriptionOptions; track plan.value) {
            <mat-option [value]="plan.value">{{ plan.label }}</mat-option>
            }
          </mat-select>
          @if (form.get('subscription')?.invalid && form.get('subscription')?.touched) {
          <mat-error>Оберіть план</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Рівень доступу ШІ</mat-label>
          <mat-select formControlName="aiCvParserAccess">
            @for (level of aiCvParserOptions; track level.value) {
            <mat-option [value]="level.value">{{ level.label }}</mat-option>
            }
          </mat-select>
          @if (form.get('aiCvParserAccess')?.invalid && form.get('aiCvParserAccess')?.touched) {
          <mat-error>Оберіть рівень доступу</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="form-row form-row--end-date">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Кінець підписки</mat-label>
          <input matInput formControlName="endDate" [matDatepicker]="picker" [min]="minEndDate" />
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          @if (form.get('endDate')?.invalid && form.get('endDate')?.touched) {
          <mat-error>Дата кінця підписки обов'язкова</mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="form-actions">
      <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid" class="submit-btn">
        <mat-icon>check_circle</mat-icon>
        Створити портал
      </button>
    </div>
  </form>
</div>
